import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { JobDetailEffects } from './job-detail.effects';
import * as fromJobDetailState from './job-detail.reducer';
import { AddEditShiftsDialogModule } from '../../shared/add-edit-shift-dialog/add-edit-shift.module';

@NgModule({
	imports: [
		AddEditShiftsDialogModule,
		StoreModule.forFeature(
			fromJobDetailState.jobDetailFeatureKey,
			fromJobDetailState.reducer
		),
		EffectsModule.forFeature([JobDetailEffects]),
	],
})
export class JobDetailStateModule {}
